import { Navigate, useMatch } from '@tanstack/react-location';
import { getLastVisitedPage } from '@frontend/auth-helpers';
import { useShell } from '@frontend/shell-utils';
import { SignInView } from '@frontend/sign-in';

export default function SignInPage() {
  const {
    data: { authenticated },
  } = useMatch();
  const shell = useShell();

  const lastVisitedPage = getLastVisitedPage();

  const redirectPath = shell.isShell
    ? lastVisitedPage.length > 1 &&
      lastVisitedPage !== '/home/dashboard' &&
      lastVisitedPage !== '/sign-in/callback' &&
      lastVisitedPage !== '/sign-in'
      ? lastVisitedPage
      : '/home/dashboard'
    : '/portal';

  return authenticated ? <Navigate to={redirectPath} /> : <SignInView />;
}
